(() => {
  const shops = document.querySelectorAll('[data-lumi-shop]');
  if (!shops.length) return;

  shops.forEach((shop) => {
    const buttons = [...shop.querySelectorAll('[data-lumi-shop-filter]')];
    const cards = [...shop.querySelectorAll('[data-lumi-shop-card]')];
    const resultCount = shop.querySelector('[data-lumi-shop-result-count]');
    const empty = shop.querySelector('[data-lumi-shop-empty]');

    const matches = (card, filter) => {
      if (filter === 'all') return true;
      const group = card.dataset.lumiGroup || '';
      const sub = card.dataset.lumiSub || '';
      if (filter === group) return true;
      return filter === `${group}-${sub}`;
    };

    const countFor = (filter) => cards.filter((card) => matches(card, filter)).length;

    buttons.forEach((button) => {
      const filter = button.dataset.lumiShopFilter;
      const target = shop.querySelector(`[data-lumi-filter-count="${filter}"]`);
      if (target) target.textContent = countFor(filter);
    });

    const applyFilter = (filter, clickedButton) => {
      let visible = 0;
      cards.forEach((card) => {
        const show = matches(card, filter);
        card.hidden = !show;
        if (show) visible += 1;
      });

      buttons.forEach((button) => {
        const active = button === clickedButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (resultCount) {
        const label = clickedButton?.querySelector('span')?.textContent?.trim() || 'All products';
        resultCount.textContent = `${visible} ${visible === 1 ? 'product' : 'products'} · ${label}`;
      }
      if (empty) empty.hidden = visible !== 0;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.lumiShopFilter, button));
    });

    const initial = buttons.find((button) => button.dataset.lumiShopFilter === 'all') || buttons[0];
    if (initial) applyFilter(initial.dataset.lumiShopFilter, initial);
  });
})();
